import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {InternalSettings, IpRule, IpRuleListResponse, ListResponse} from "../http/protocol";

export class IPRulesService extends AbstractAdminEntityService<IpRule,IpRuleListResponse>{
    constructor(http: HttpService) {
        super("/ip-rules", http);
    }
}